export const APP_NAME = window['APP_NAME'];
export const APP_VERSION = window['APP_VERSION'];
export const BUILD_ID = window['BUILD_ID'];
export const SONIKA_AZURE_INSTRUMENTATION_KEY = window['SONIKA_AZURE_INSTRUMENTATION_KEY'];
export const SONIKA_FRONT_URLS = JSON.parse(window['SONIKA_FRONT_URLS']);
export const SONIKA_GRAPHQL_API_URL = window['SONIKA_GRAPHQL_API_URL'];
export const SONIKA_REST_API_URL = window['SONIKA_REST_API_URL'];
